import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent } from 'react';
export function useUnmount(func) {
  const $ = _c(3);
  const onUnmount = useEffectEvent(func);
  let t0;
  if ($[0] !== onUnmount) {
    t0 = () => () => onUnmount();
    $[0] = onUnmount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
}